import { get, patch, post, postFormData } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  state: {
    navItems: []
  },

  getters: {},

  mutations: {
    setNavItems: (state, navItems) => {
      state.navItems = navItems;
    }
  },

  actions: {
    index: () => get('applications'),
    getNavMenuItems({ commit }) {
      return get(`applications/nav-menu`).then(response => {
        commit('setNavItems', response.data.data);

        return response;
      });
    },
    storeApp: (_, payload) => postFormData('applications', payload),
    showApp: (_, id) => get(`applications/${id}`),
    updateApp: (_, payload) => postFormData(`applications/${payload.id}`, payload.data),
    storeLayout: (_, payload) => post(`applications/${payload.id}/layout`, payload),
    updateLayout: (_, payload) => patch(`applications/${payload.id}/layout`, payload),
    updateSettings: (_, payload) =>
      patch(`applications/${payload.id}/settings`, payload)
  }
};
